import React, { Component } from 'react';
// import { Switch, Route, Redirect } from 'react-router-dom';
import { Switch, Route } from 'react-router-dom';
// import { bindActionCreators } from 'redux'
import './App.css';
import PropTypes from 'prop-types';
import Menu from '../Menu';
import Footer from '../Footer';
import routes from '../../routes';
import ResizeDetector from 'react-resize-detector';
import objectFitImages from 'object-fit-images';
import { Helmet } from "react-helmet";
import { DEAFULTTITLE, DEAFULTIMAGE } from '../../constants/Meta';
import CookieNotice from "../CookieNotice/CookieNotice";

class App extends Component {
  static childContextTypes = {
    width: PropTypes.number,
  };

  state = {
    width: undefined,
  };

  getChildContext = () => ({
    width: this.state.width,
  });

  onResize = width => {
    this.setState({ width });
  };

  render() {
    // polyfill object-fit for IE
    objectFitImages()

    return (
      <div className="app">
        <Helmet defaultTitle={DEAFULTTITLE} titleTemplate={`%s | ${DEAFULTTITLE}`}>
          <meta property="og:title" content={`${DEAFULTTITLE}`} />
          <meta property="og:image" content={DEAFULTIMAGE} />
        </Helmet>
        <ResizeDetector handleWidth onResize={this.onResize} />
        <Menu />
        <div className="app__wrapper">
          <Switch>
              {/*<Redirect from="/internships/" to="/internships" />*/}
              {/*<Redirect from="/vacancies/" to="/vacancies" />*/}
              {/*<Redirect from="/workers/" to="/workers" />*/}
            {routes.map((route, index) => <Route key={index} {...route} />)}
          </Switch>
          <Footer />
        </div>
          <CookieNotice/>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App/index.js